import { useQuery } from 'react-query';
import feathersClient from '../../apiClient';
import { Divider } from '@tymbe/ty-components/indicators';
import { ApplicationInfo } from '../../pages/administration/absence/components/applicationDetail/ApplicationInfo';
import { ApplicationExcuses } from '../ApplicationExcuse/ApplicationExcuses';
import { MobileShiftCard } from '../MobileShiftCard/MobileShiftCard';

type ApplicationDetailProps = {
  applicationId: string;
  activeExcuseId?: string;
};

export const ApplicationDetail = ({
  applicationId,
  activeExcuseId,
}: ApplicationDetailProps) => {
  const { data: application, isLoading } = useQuery(
    ['applicationDetail', applicationId],
    async () =>
      feathersClient.service('application').get(applicationId, {
        query: {
          $eager: '[excuses.files, shift.company, contract.documentType]',
          $modify: { withDeleted: true },
        },
      })
  );

  if (isLoading || !application || !application.shift) {
    return null;
  }

  return (
    <div>
      <MobileShiftCard shift={application.shift!} />
      <div className="p-6">
        <ApplicationInfo application={application} />
        {application.excuses.length > 0 && <Divider />}
        <ApplicationExcuses
          excuses={application.excuses}
          activeExcuseId={activeExcuseId}
        />
      </div>
    </div>
  );
};
